import * as React from 'react';
import { Play, Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useEnqueueOptimisation } from '@/hooks/optimisation/use-enqueue-optimisation';
import { useToast } from '@/hooks/use-toast';

interface OptimiseButtonProps {
  projectId: number;
  disabled?: boolean;
}

export function OptimiseButton({ projectId, disabled }: OptimiseButtonProps) {
  const { toast } = useToast();
  const enqueue = useEnqueueOptimisation(projectId);

  const handleClick = () => {
    enqueue.mutate(
      {},
      {
        onSuccess: (data) => {
          toast({ title: `Optimisation queued (run #${data.runId})` });
        },
        onError: () => {
          toast({ variant: 'destructive', title: 'Failed to enqueue optimisation' });
        },
      },
    );
  };

  return (
    <Button
      onClick={handleClick}
      disabled={disabled || enqueue.isPending}
      size="sm"
    >
      {enqueue.isPending ? (
        <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" />
      ) : (
        <Play className="h-3.5 w-3.5 mr-1.5" />
      )}
      {enqueue.isPending ? 'Queueing…' : 'Optimise'}
    </Button>
  );
}
